import {StyleParamType, wixColorParam, wixFontParam, createStylesParams} from '@wix/tpa-settings'
import {StyleType} from '@wix/editor-platform-ooi-metadata-resolver'

import {colorMetadata, fontMetadata, numberMetadata} from '../../../utils/builderMetadata'

export type TimeSlotsDefaultStylesParams = {
  timeSlotsDefaultFont: StyleParamType.Font
  timeSlotsDefaultColor: StyleParamType.Color
  timeSlotsDefaultFillOpacityColor: StyleParamType.Color
  timeSlotsDefaultBorderOpacityColor: StyleParamType.Color
  timeSlotsDefaultBorderWidth: StyleParamType.Number
  timeSlotsDefaultCornerRadius: StyleParamType.Number
}

export const timeSlotsDefaultStylesParams = createStylesParams<TimeSlotsDefaultStylesParams>({
  timeSlotsDefaultFont: {
    type: StyleParamType.Font,
    getDefaultValue: (params) =>
      wixFontParam('Body-M', {
        size: params.isMobile ? 14 : 16,
      })(params),
    metadata: fontMetadata('Body-M', 16, 14),
  },
  timeSlotsDefaultColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
    metadata: colorMetadata(StyleType.color, 'color-5', 1),
  },
  timeSlotsDefaultFillOpacityColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 1),
    metadata: colorMetadata(StyleType.backgroundColor, 'color-1', 1),
  },
  timeSlotsDefaultBorderOpacityColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.6),
    metadata: colorMetadata(StyleType.borderColor, 'color-5', 0.6),
  },
  timeSlotsDefaultBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
    metadata: numberMetadata(StyleType.borderWidth, {defaultValue: 1}),
  },
  timeSlotsDefaultCornerRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: numberMetadata(StyleType.borderRadius, {defaultValue: 0}),
  },
})

export type TimeSlotsSelectedStylesParams = {
  timeSlotsSelectedTextColor: StyleParamType.Color
  timeSlotsSelectedFillOpacityColor: StyleParamType.Color
  timeSlotsSelectedBorderOpacityColor: StyleParamType.Color
  timeSlotsSelectedBorderWidth: StyleParamType.Number
  timeSlotsSelectedCornerRadius: StyleParamType.Number
}

export const timeSlotsSelectedStylesParams = createStylesParams<TimeSlotsSelectedStylesParams>({
  timeSlotsSelectedTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
    metadata: colorMetadata(StyleType.color, 'color-5', 1),
  },
  timeSlotsSelectedFillOpacityColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 0.1),
    metadata: colorMetadata(StyleType.backgroundColor, 'color-8', 0.1),
  },
  timeSlotsSelectedBorderOpacityColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 0.1),
    metadata: colorMetadata(StyleType.borderColor, 'color-8', 0.1),
  },
  timeSlotsSelectedBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
    metadata: numberMetadata(StyleType.borderWidth, {defaultValue: 1}),
  },
  timeSlotsSelectedCornerRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: numberMetadata(StyleType.borderRadius, {defaultValue: 0}),
  },
})

export type TimeSlotsClosedStylesParams = {
  timeSlotsClosedFillOpacityColor: StyleParamType.Color
  timeSlotsClosedCornerRadius: StyleParamType.Number
}

export const timeSlotsClosedStylesParams = createStylesParams<TimeSlotsClosedStylesParams>({
  timeSlotsClosedFillOpacityColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.1),
    metadata: colorMetadata(StyleType.backgroundColor, 'color-5', 0.1),
  },
  timeSlotsClosedCornerRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: numberMetadata(StyleType.borderRadius, {defaultValue: 0}),
  },
})
